// Endereço do app mobile por tipo de operação.
// Varejo puro (configUI.isRetail === "true") roda em domínio próprio, com o
// slug da empresa como subdomínio: https://{slug}.mooda.com.br/
// Atacado (undefined/"false") e operação mista ("both") seguem no domínio
// padrão, com o slug no path: https://mobile.mooda.app.br/{slug}/
export function isRetailOnly(isRetail) {
  return String(isRetail) === "true";
}

// Retorna a base já com o slug — basta concatenar a página ("home", "employee").
// retailDomain vazio (fora de production) cai sempre na base padrão.
export function pickUrlMooda(isRetail, slug, urlDefault, retailDomain) {
  if (retailDomain && isRetailOnly(isRetail) && slug) {
    return `https://${slug}.${retailDomain}/`;
  }
  return urlDefault + (slug ? slug + "/" : "");
}
